import { Injectable, Inject, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UMPCategory, Utils } from '../utils/utils';
import { BehaviorSubject, Observable, Subject, filter, switchMap, tap } from 'rxjs';
import { ComponentTool } from '../interfaces/componenttool';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NavItem } from '../components/sidenav/navitem';

@Injectable()
export class DefaultValuesService implements OnInit {
    onTenantChanged: EventEmitter<string> = new EventEmitter<string>();
    onControllerTypeChanged: EventEmitter<ControllerType> = new EventEmitter<ControllerType>();
    onLanguageChanged: EventEmitter<Language> = new EventEmitter<Language>();
    onStageChanged: EventEmitter<string> = new EventEmitter<string>();
    onManagementIdChanged: EventEmitter<string> = new EventEmitter<string>();

    private hierarchyTypeKey = 'hierarchyType';

    country: string = '';
    tenant: string = '';
    dialerCode: string = '';
    regulatoryCode: string | undefined = undefined;
    tenants: Tenant[] = [];
    branches: BranchHierarchy[] = [];
    environments: string[] = [];
    waveId: number | undefined = undefined;
    oshWaveId: number | undefined = undefined;
    quarterId: number | undefined = undefined;
    public groupList: { Personae: string; Id: string; UmpCategory: UMPCategory }[] = [];
    public secondaryTenList = new Set<string>();
    componentToolEnum: typeof ComponentTool = ComponentTool;


    public controllerTypeMessageSource = new Subject<ControllerType>();
    controllerTypeMessageChanges$ = this.controllerTypeMessageSource.asObservable();

    public languageMessageSource = new Subject<Language>();
    languageMessageChanges$ = this.languageMessageSource.asObservable();

    public tenantMessageSource = new Subject<string>();
    tenantMessageChanges$ = this.tenantMessageSource.asObservable();

    public stageMessageSource = new Subject<string>();
    stageMessageChanges$ = this.stageMessageSource.asObservable();

    public groupFunctionMessageSource = new Subject<string>();
    groupFunctionMessageChanges$ = this.groupFunctionMessageSource.asObservable();

    public managementIdMessageSource = new Subject<string>();
    managementIdMessageChanges$ = this.managementIdMessageSource.asObservable();

    public fiscalYearMessageSource = new Subject<string>();
    fiscalYearMessageChanges$ = this.fiscalYearMessageSource.asObservable();

    public managementName = "";
    
    public getManagementNameParts(): { prefix: string; gfParts: string[]; selectedGF: string } | null {
        if (!this.managementName?.includes('/') || !this.groupFunction) return null;
        
        const parts = this.managementName.split(' - ');
        const gfPart = parts[parts.length - 1];
        
        if (parts.length < 3 || !gfPart.includes('/')) return null;
        
        return {
            prefix: parts.slice(0, -1).join(' - ') + ' - ',
            gfParts: gfPart.split('/').map(gf => gf.trim()),
            selectedGF: this.groupFunction.trim()
        };
    }

    public periodMessageSource = new Subject<string>();
    periodMessageChanges$ = this.periodMessageSource.asObservable();

    public countryMessageSource = new Subject<string>();
    countryMessageChanges$ = this.countryMessageSource.asObservable();

    public isControllerOwnerChange = new Subject<boolean>();
    isControllerOwnerChange$ = this.isControllerOwnerChange.asObservable();

    public resetBulkGroupSource = new Subject<boolean>();
    resetBulkGroupTrigger$ = this.resetBulkGroupSource.asObservable();

    public groupListChangedSource = new Subject<void>();
    groupListChanged$ = this.groupListChangedSource.asObservable();

    public resetUserSearchSource = new BehaviorSubject<boolean>(false);
    resetUserSearchTrigger$ = this.resetUserSearchSource.asObservable();

    public dataAnalyticsTreeSource = new BehaviorSubject<string | undefined>(undefined);
    dataAnalyticsTreeSourceChanges$ = this.dataAnalyticsTreeSource.asObservable();

    language: Language = {} as Language;
    languages: Language[] = [];

    controllertype: ControllerType = {
        Description: '',
        BK: '',
        ControllerTypeID: -1,
        DeployErrorCodes: false,
        DeployOpModes: false,
        IsUsingErrorCodes: false,
        CountryOwnerName: '',
        CountryOwnerCode: ''
    };

    controllertypes: ControllerType[] = [];
    controllertypesdigitalservices: ControllerType[] = [];
    noDigitalServicesConfigured: boolean = false;

    groupFunction: string = ''
    fiscalYear: number;
    period: number = -1
    managementid = '-1';
    managementids: ManagementId[] = []
    groupFunctions: string[] = []
    hierarchyType: string = '';
    mersyGroupFunctions: string[] = [];
    hasProductTypeRoles: boolean = false;
    hasLineOfBusinessRoles: boolean = false;
    isadminuser = false;
    isDomainExpertUser = false;
    isCountryBackendStableUser = false;
    isCountryBackendProdUser = false;
    isControllerOwner = false;
    isHomeUser = false;
    isExternalUser = false;
    isReadonlyUser = false;
    isDevUserManagementPortalUser = false;
    isProdUserManagementPortalUser = false;
    IsMersyUser: boolean | undefined = undefined;
    isMersyAdminUser = false;
    isMersyAdminBranchExcellenceUser = false;
    isMersyCDPTaxAdmin = false;
    isMersyCDPTaxRevoker = false;
    isMersyCDPTaxReporter = false;
    isMersyCDPTaxViewer = false;
    isMersyBranchManagerBranchExcellenceUser = false;
    isMersyCoachBranchExcellenceUser = false;
    isMersyViewerBranchExcellenceUser = false;
    isMersyOwnerUser = false;
    isMersyReporterUser = false;
    isMersyDelegatedUser = false;
    isMersyViewerUser = false;
    isDevMersyUMPUser = false;
    isProdMersyUMPUser = false;
    isEMTManagerUser = false;
    isEMTFactorySupportEngineer = false;
    isEMTFieldSupportEngineer = false;
    isMfgManagerUser = false;
    isUMPDataAnalyticsUser = false;
    isHomManagerUser = false;
    isGlobalSystemAdmin = false;
    isGlobalLocalUserMgmt = false;
    isUserMgmtFldBranchesUser = false;
    isDevADOGroupUMPUser = false;
    isProdADOGroupUMPUser = false;
    isPBIWorkspaceCreatorUser = false;
    IsLicenseManagerUser = false;
    isMersyReporterBranchReportingUser = false;
    isMersyDelegatedBranchReportingUser = false;
    isMersyViewerBranchReportingUser = false;
    isMersyRevokerUser = false;
    isMersyRevokerBranchReportingUser = false;
    isMersyAdminMarketQueryUser = false;
    isMersyOwnerMarketQueryUser = false;
    isMersyReporterMarketQueryUser = false;
    isMersyDelegateMarketQueryUser = false;
    isMersyViewerMarketQueryUser = false;
    isMersyRevokerMarketQueryUser = false;

    isActualReportingEnabled = false;
    isMonthlyOPLEnabled = false;
    isYearlyOPLEnabled = false;
    isActualBranchReportingEnabled = false;
    isMonthlyOPLBranchReportingEnabled = false;
    isYearlyOPLBranchReportingEnabled = false;
    isMFGAdminUser = false;
    isMFGEquipmentManagerUser = false;
    isMFGAdminPDCSUser = false;
    isMFGAdminCenterUser = false;
    isMFGContractEngineerUser = false;
    isDESConfAdmUser = false;
    isMgmtHierarchyAdmin = false;

    isMersyNiOpsAdminUser = false;
    isMersyNiOpsReporterUser = false;

    isMersyAdminSafetySystemExcellence = false;
    isMersyAssessorSafetySystemExcellence = false;
    isMersyReporterSafetySystemExcellence = false;

    isMersyAdminINCO = false;
    isMersyUserINCO = false;

    isMaxRulebookGTL = false;
    isMaxRulebookSupervisorAppUser = false;

    isTenantRemoteActionAdminUser = false;
    isControllerRemoteActionAdminUser = false;


    public loadInitialData = false
    selectedItem = Number(localStorage.getItem('currentSelectedItem'));

    classname: string = Utils.getDialogHideClassName();

    stage = 1;
    stageAfterRedirect = 1;
    session: Session | undefined;
    componentTool: ComponentTool = ComponentTool.Undefined;
    public componentToolSource = new BehaviorSubject<ComponentTool>(ComponentTool.Undefined);
    componentToolChanges$ = this.componentToolSource.asObservable();

    menuClusters: NavItem[] | undefined;
    components: NavItem[] = [];

    passedTenants: string[] = [];
    passedRoles: string[] = [];
    passedCdpGroups: string[] = [];
    // UMP

    umpFilters: UserFilter = {
        cdpList: [],
        nodeId: [],
        nodes: [],
        page: 0,
        pageSize: 12,
        personaId: [],
        personas: [],
        tenant: [],
        tenants: [],
        userPrincipalName: '',

    };

    //wiki
    wikiTabName: string | null = null;
    routeSeg = "";
    private triggerWikiMng = new Subject<void>();
    private routeChanged = new Subject<void>();
    public healthScorePopulation = new BehaviorSubject<number | undefined>(undefined);
    healthScorePopObs$ = this.healthScorePopulation.asObservable();

    public currentTenant = new BehaviorSubject<string | undefined>(undefined);
    currentTenantObs$ = this.currentTenant.asObservable();

    public RegCode = new BehaviorSubject<string | undefined>(undefined);
    RegCodeChanged$ = this.RegCode.asObservable();

    public wave = new BehaviorSubject<number | undefined>(undefined);
    wave$ = this.wave.asObservable();

    public oshWave = new BehaviorSubject<number | undefined>(undefined);
    oshWave$ = this.oshWave.asObservable();

    public quarter = new BehaviorSubject<number | undefined>(undefined);
    quarter$ = this.quarter.asObservable();



    constructor(
        private route: ActivatedRoute,
        private router: Router
        , @Inject('BASE_URL') private baseUrl: string
    ) {
        this.fiscalYear = -1;
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                var temp = event.url.split("/");
                this.routerChange(event.url.length > 1 ? temp[1] : "home")
            }
        });
        this.ngOnInit();
    }

    ngOnInit() {
        this.controllertype.ControllerTypeID = -1;
        this.hierarchyType = this.getSessionHierarchyType();
    }

    /**
     * return true if is to show reference language
     */
    public isToShowReference(): boolean {
        return this.language.LanguageId !== Utils.getDefaultLaguangeID();
    }


    // This is for BehaviorSubject
    //notifyLanguageChange(l: Language) {
    //    this.selectedLanguageSubject.next(l);
    //}


    removeGroupListItem(id: string) {
        const remainingItems = this.groupList.filter((item) => item.Id !== id);
        if (remainingItems.length !== this.groupList.length) {
            this.groupList = remainingItems;
            this.groupListChangedSource.next();
        }
    }
    clearGroupListItem() {
        this.groupList = [];
        this.groupListChangedSource.next();
        this.resetBulkGroupSource.next(true);
    }

    addGroupListItem(item: { Personae: string; Id: string; UmpCategory: UMPCategory }) {
        if (this.groupList.some((existingItem) => existingItem.Id === item.Id)) {
            return;
        }

        this.groupList.push(item);
        this.groupListChangedSource.next();
    }

    notifyControllerTypeChange(message: ControllerType) {
        this.controllerTypeMessageSource.next(message);
    }

    notifyLanguageChange(message: Language) {
        this.languageMessageSource.next(message);
        this.currentTenant.next(this.controllertype.BK)
    }
    notifyCurrentTen(ten: string) {
        this.currentTenant.next(ten)
    }

    notifyTenantChange(message: string) {
        this.tenantMessageSource.next(message);
    }

    notifyStageChange(message: string) {
        this.stageMessageSource.next('');
    }

    notifyManagementIdChange() {
        this.managementIdMessageSource.next('');
    }

    notifyFiscalYearChange() {
        this.fiscalYearMessageSource.next('');
    }

    notifyGroupFunctionChange() {
        this.groupFunctionMessageSource.next('');
    }

    notifyPeriodChange() {
        this.periodMessageSource.next('');
    }

    notifyCountryChange(message: string) {
        this.country = message
        this.countryMessageSource.next(message);
    }

    notifyIsControllerOwnerChange() {
        this.isControllerOwnerChange.next(this.isControllerOwner);
    }

    notifydataAnalyticsTreeSourceChange() {
        this.dataAnalyticsTreeSource.next('');
    }

    getIsControllerOwner() {
        return this.isControllerOwner;
    }

    canShowUploadButtons() {
        return (this.getIsControllerOwner() || this.language.LanguageCultureName !== 'en-US');
    }

    //wiki
    routerChange(routeSegment) {
        this.wikiTabName = null;
        this.routeSeg = routeSegment;
        this.routeChangedFunction();
    }

    defaultComponentTab(tthis: any) {
        this.wikiTabName = tthis.tabGroup._tabs?.first?.textLabel?.replaceAll(" ", "_");
    }

    updateComponentTab(newTabName: any) {
        this.wikiTabName = newTabName?.replaceAll(" ", "_");
        this.routeChangedFunction();
    }

    triggerWikiFunction() {
        this.triggerWikiMng.next();
    }

    get triggerWikiFunctionObservable() {
        return this.triggerWikiMng.asObservable();
    }

    routeChangedFunction() {
        this.routeChanged.next();
    }

    get routeChangedObservable() {
        return this.routeChanged.asObservable();
    }

    updatePopulation(newValue: number) {
        this.healthScorePopulation.next(newValue);
    }



    updateRegCode(newValue) {
        this.RegCode.next(newValue);
    }

    updateWave(newValue) {
        this.waveId = newValue;
        this.wave.next(newValue);
    }

    updateOshWave(newValue) {
        this.oshWaveId = newValue;
        this.oshWave.next(newValue);
    }

    updateQuarter(newValue) {
        this.quarterId = newValue;
        this.quarter.next(newValue);
    }

    isDataAnalytStage(): boolean {
        return this.stageAfterRedirect == 4
    }

    userCanEditMersy(): boolean {
        return this.isMersyAdminUser
            || this.isMersyOwnerUser
            || this.isMersyRevokerUser
            || this.isMersyRevokerBranchReportingUser
            || this.isMersyReporterUser
            || this.isMersyReporterBranchReportingUser
            || this.isMersyDelegatedUser
            || this.isMersyDelegatedBranchReportingUser;
    }

    userCanReleaseMersy(): boolean {
        return this.isMersyAdminUser
            || this.isMersyOwnerUser
            || this.isMersyRevokerUser
            || this.isMersyRevokerBranchReportingUser
            || this.isMersyReporterUser
            || this.isMersyReporterBranchReportingUser;
    }

    userCanRevokeMersy(): boolean {
        return this.isMersyAdminUser
            || this.isMersyOwnerUser
            || this.isMersyRevokerUser
            || this.isMersyRevokerBranchReportingUser;
    }

    userCanEditPEReporting(): boolean {
        return this.isMersyCDPTaxAdmin
            || this.isMersyCDPTaxReporter
            || this.isMersyCDPTaxRevoker
    }

    userCanRevokePEReporting(): boolean {
        return this.isMersyCDPTaxAdmin
            || this.isMersyCDPTaxRevoker;
    }

    userCanCheckUserHistory(): boolean {
        return this.isadminuser
            || this.isMersyAdminUser
            || this.isMersyNiOpsAdminUser
            || this.isMersyAdminBranchExcellenceUser
            || this.isMersyAdminMarketQueryUser
            || this.isMersyAdminSafetySystemExcellence
            || this.isMersyCDPTaxAdmin
            || this.isMersyAdminINCO;
    }

    userHasSafetySystemExcellenceRole(): boolean {
        return this.isMersyAdminUser
            || this.isMersyAdminSafetySystemExcellence
            || this.isMersyAssessorSafetySystemExcellence
            || this.isMersyReporterSafetySystemExcellence;
    }

    isSafetySystemExcellenceAdmin(): boolean {
        return this.isMersyAdminUser
            || this.isMersyAdminSafetySystemExcellence;
    }

    setHierarchyType(value: string): void {
        this.hierarchyType = value;
        sessionStorage.setItem(this.hierarchyTypeKey, value);
    }

    public getSessionHierarchyType(): string {
        return sessionStorage.getItem(this.hierarchyTypeKey) ?? "";
    }

    get componentName(): string {
        switch (this.componentTool) {
            case this.componentToolEnum.Mersy:
                return 'Mersy';
            case this.componentToolEnum.Rulebook:
                return 'Rulebook';
            default:
                return '';
        }
    }
    setComponentTool(newTool: ComponentTool): void {
        this.componentTool = newTool;
        this.componentToolSource.next(newTool);
    }
}